import { useCallback, useEffect, useState } from 'react';
import PaymentPageView from '../presentation/PaymentPageView';
import { checkoutDetailsDefaultValue } from 'common/utilities/CheckoutUtils';
import { useDispatch } from 'react-redux';

const PaymentPage = props => {
  const dispatch = useDispatch();
  const [paymentDetails, setPaymentDetails] = useState(checkoutDetailsDefaultValue);

  const updatePaymentDetails = useCallback(param => {
    setPaymentDetails && setPaymentDetails(prevState => ({ ...prevState, ...param }));
  }, []);

  useEffect(() => {
    updatePaymentDetails({
      dispatch,
      paymentEnabled: true,
      paymentProvider: 'globalpayment',
      allowedTenders: ['credit-card', 'applepay', 'googlepay', 'pay-by-cash'],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return <PaymentPageView {...props} paymentDetails={paymentDetails} updatePaymentDetails={updatePaymentDetails} />;
};

export default PaymentPage;
